import ButtonBase from '@mui/material/ButtonBase';
import type { ReactNode } from 'react';
import { controlHeight, radius } from '@/shared/theme';

interface ToggleChipProps {
  selected: boolean;
  onClick: () => void;
  children: ReactNode;
  disabled?: boolean;
  /** 36 (filter row, default) or 34 (forms). */
  height?: number;
  title?: string;
}

/** Pill toggle of the prototype's location filters: tinted primary when selected. */
export function ToggleChip({
  selected,
  onClick,
  children,
  disabled,
  height = controlHeight.md,
  title,
}: ToggleChipProps) {
  return (
    <ButtonBase
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      title={title}
      sx={(theme) => ({
        display: 'inline-flex',
        alignItems: 'center',
        gap: '7px',
        flex: 'none',
        whiteSpace: 'nowrap',
        height,
        px: '13px',
        borderRadius: radius.control,
        fontFamily: theme.typography.fontFamily,
        fontSize: 12.5,
        fontWeight: 600,
        transition: 'background-color .15s ease, border-color .15s ease, color .15s ease',
        ...(selected
          ? {
              background: theme.vars.palette.md.primary050,
              border: `1px solid color-mix(in srgb, ${theme.vars.palette.md.primary} 38%, transparent)`,
              color: theme.vars.palette.md.primary,
            }
          : {
              background: theme.vars.palette.md.panel,
              border: `1px solid ${theme.vars.palette.md.border}`,
              color: theme.vars.palette.md.muted,
              '&:hover': { borderColor: theme.vars.palette.md.borderStrong },
            }),
        '&.Mui-focusVisible': {
          outline: `2px solid ${theme.vars.palette.md.primary}`,
          outlineOffset: 2,
        },
        '&.Mui-disabled': { opacity: 0.5 },
      })}
    >
      {children}
    </ButtonBase>
  );
}
